import React from 'react'
import { useState, useEffect } from 'react'
import { useAddNewAnswerMutation, useUpdateAnswerMutation } from './answersApiSlice'
import { useNavigate } from 'react-router-dom'
import { answersConfig } from '../../configure/answersConfig'
//Color picker
import { HexColorPicker } from 'react-colorful';

const Poll = () => {

    var stripeColor = '#404040'
    const [color, setColor] = useState(stripeColor)
    const [ua1, setUa1] = useState(-1)
    const [ua2, setUa2] = useState(-1)
    const [ua3, setUa3] = useState(-1)
    const [ua4, setUa4] = useState(-1)
    const [ua5, setUa5] = useState(-1)
    const [ua6, setUa6] = useState(-1)
    const [ua7, setUa7] = useState(-1)
    const [last, setLast] = useState(-1)
    const [id, setId] = useState('0')

    useEffect(() => {
        if (last!==-1) {
            console.log([color, ua1, ua2, ua3, ua4, ua5, ua6, ua7]);
            if (id==='0') {
                console.log('Poll -> create new Set from useEffect change. id : '+id); //DEV
                newSet();
                setId('whatever');
            } else {
                console.log('Poll -> update Set from useEffect change. id : '+id); //DEV
                updateSet();
            }
        }
      }, [color, ua1, ua2, ua3, ua4, ua5, ua6, ua7, last]);

    const [addNewAnswer, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddNewAnswerMutation()

    const [updateAnswer, {
        isLoading: isLoadingUp,
        isSuccess: isSuccessUp,
        isError: isErrorUp,
        error: errorUp
    }] = useUpdateAnswerMutation()

    const navigate = useNavigate();

    //check if button for ending visible
    const completed = [ color!=='#404040'?true:false, ua1!==-1?true:false, ua2!==-1?true:false, ua3!==-1?true:false, ua4!==-1?true:false, ua5!==-1?true:false, ua6!==-1?true:false, ua7!==-1?true:false ].every(v => v === true)

    const newSet = async (e) => {
        let colorId = color.substring(1);
        await addNewAnswer({color: colorId, answers: [ua1, ua2, ua3, ua4, ua5, ua6, ua7], last: last})
        .then(result => {setId(result.data.message._id)})
    }

    const updateSet = async (e) => {
        let colorId = color.substring(1);
        await updateAnswer({id: id, color: colorId, answers: [ua1, ua2, ua3, ua4, ua5, ua6, ua7], last: last})
    }

    function handleQuestionChange (selectorId, value) {
        //set values
        //console.log(selectorId+' : '+value); //DEV
        
        switch (selectorId) {
            case '0':
                setUa1(parseInt(value));
                setLast(0);
                break;
            case '1':
                setUa2(parseInt(value));
                setLast(1);
                break;
            case '2':
                setUa3(parseInt(value));
                setLast(2);
                break;
            case '3':
                setUa4(parseInt(value));
                setLast(3);
                break;
            case '4':
                setUa5(parseInt(value));
                setLast(4);
                break;
            case '5':
                setUa6(parseInt(value));
                setLast(5);
                break;
            case '6':
                setUa7(parseInt(value));
                setLast(6);
                break;
            default:
                break;
        }
    }

    function handleColorChange (value) {
        setColor(value);
        console.log('New color value : '+value); //DEV
        setLast(7);
    }

    function endButton () {
        const content = document.getElementById('poll');
        content.style.display = 'none';
        const final = document.getElementById('final');
        final.style.display = 'block';
        return
    }

    const content = (
        <>
            <div className="colorstripe" id="colorstripe" style={{backgroundColor: color}}></div>
            <div className="poll" id="poll">
                <h2>
                    Welcome to our poll. Have fun.
                </h2>
                <p>
                    <label>Pick your favorite color as your id.</label>
                </p>
                
                    <HexColorPicker color={color} onChange={handleColorChange} />
                
                {answersConfig.map(({n, question, a1, a2, a3, a4, a5, a6, a7}, index) => (
                    <React.Fragment key={index}>
                        <p>
                            <label>{question}</label>
                        </p>
                        <p>
                            <select name={index} className='selector' onChange={(e) => handleQuestionChange(e.target.name, e.target.value)}>
                                <option value='-1'>--- please choose your answer ---</option>
                                {(a1)?<option className='selectorOption' value='0'>{a1}</option>:null}
                                {(a2)?<option className='selectorOption' value='1'>{a2}</option>:null}
                                {(a3)?<option className='selectorOption' value='2'>{a3}</option>:null}
                                {(a4)?<option className='selectorOption' value='3'>{a4}</option>:null}
                                {(a5)?<option className='selectorOption' value='4'>{a5}</option>:null}
                                {(a6)?<option className='selectorOption' value='5'>{a6}</option>:null}
                                {(a7)?<option className='selectorOption' value='6'>{a7}</option>:null}
                            </select>
                        </p>
                    </React.Fragment>
                )) }
                <p>
                    {
                        (completed)?
                        <button type="button" id="endButton" className="pollbutton" onClick={endButton} >I'm happy with my answers! Save them for the next generation to come.</button>
                        :<button type="button" id="endButton" className="pollbutton_disabled" >I'm happy with my answers! Save them for the next generation to come.</button>
                    }
                </p>
            </div>
            <div className="final" id="final">
                    <h1>Thanks for participating in our poll!</h1>
                    <p>Find the results at</p>
                    <p><a href="https://luxoomdw23.onrender.com/visualize">our poll visualizer website.</a></p>
                    <p></p>
                    <p>If you have feedback on how to improve this experience</p>
                    <p><a href="mailto:designweek@luxoom.com">designweek@luxoom.com</a></p>
            </div>
        </>
    )

    return content;
}

export default Poll